export enum PrivacyLevel {
    Admin = 'admin',
    Analyst = 'analyst',
    Standard = 'standard'
}